import { useRef } from "react";

import { SelectWithValidation as StyledSelect } from "@/views/reports/SelectWithValidation";
import Button from "@components/Button";
import { Select } from "@components/Field";
import Modal, { ModalFooter, ModalTitle } from "@components/Modal";
import { i18n } from "@lingui/core";

const INTERVALS_FOR_TIME_COMPARISON = {
  daily: L.REPORTS_TIME_COMPARISON_INTERVALS_DAILY,
  weekly: L.REPORTS_TIME_COMPARISON_INTERVALS_WEEKLY,
  monthly: L.REPORTS_TIME_COMPARISON_INTERVALS_MONTHLY,
  quarterly: L.REPORTS_TIME_COMPARISON_INTERVALS_QUARTERLY,
  yearly: L.REPORTS_TIME_COMPARISON_INTERVALS_YEARLY,
};

const NewReportModal = (props) => {
  const formRef = useRef(null);
  return (
    <Modal
      show={props.templateName != null}
      onHide={props.handleHide}
      className="create-report-modal"
    >
      <form ref={formRef} noValidate onSubmit={props.handleSubmit}>
        <ModalTitle>
          {
            L[
              `REPORTS_CREATE_${String(
                props.templateName
              ).toUpperCase()}_MODAL_TITLE`
            ]
          }
        </ModalTitle>

        <label className="mt-3">
          {
            L[
              `REPORTS_CREATE_${String(
                props.templateName
              ).toUpperCase()}_MODAL_LABEL`
            ]
          }
        </label>

        <div>
          <div>
            <StyledSelect
              isMulti={props.templateName !== "time_comparison"}
              id="sourcesSelect"
              value={(
                props.alerts.map((a) => ({
                  label: a.title,
                  value: a.id,
                  uuid: a.uuid,
                  type: "search",
                })) || []
              ).concat(
                props.tags.map((a) => ({
                  label: a.name,
                  value: a.slug,
                  type: "tag",
                }))
              )}
              onChange={(selectedOptions) => {
                if (!selectedOptions) {
                  props.setAlerts([]);
                  props.setTags([]);
                  return;
                }

                let options;
                if (!Array.isArray(selectedOptions)) {
                  options = [selectedOptions];
                } else {
                  options = selectedOptions;
                }

                props.setAlerts(
                  options.length
                    ? options
                        .filter((o) => o["type"] === "search")
                        .map((o) => ({
                          id: parseInt(o.value),
                          uuid: o.uuid,
                          title: o.label,
                        }))
                    : []
                );

                props.setTags(
                  options.length
                    ? options
                        .filter((o) => o["type"] === "tag")
                        .map((o) => ({
                          slug: o.value,
                          name: o.label,
                        }))
                    : []
                );
              }}
              options={props.sourceOptions}
            />
          </div>
        </div>

        {props.templateName === "time_comparison" && (
          <>
            <label className="mt-3">
              {L.REPORTS_CREATE_TIME_COMPARISON_MODAL_INTERVAL_LABEL}
            </label>

            <div>
              <Select
                value={props.interval}
                onChange={(e) => props.setInterval(e.target.value)}
                options={Object.entries(INTERVALS_FOR_TIME_COMPARISON).map(
                  ([value, label]) => ({
                    value,
                    label: i18n._(label),
                  })
                )}
              />
            </div>
          </>
        )}

        <ModalFooter className="flex justify-end">
          <Button variant="secondary" onClick={props.handleHide}>
            {L.REPORTS_CREATE_MODAL_CANCEL_BUTTON}
          </Button>

          <Button
            onClick={() => props.handleSave(formRef.current)}
            disabled={props.createReportLoading}
          >
            {L.REPORTS_CREATE_MODAL_SAVE_BUTTON}
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default NewReportModal;
